import { AlertTitle } from "@mui/material";
import { DefaultAlert } from "./Messages";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { createForm } from "@/hooks/form/source-data/useForm";
import { AppSettings } from "@/AppSettings";
import { FC } from "react";
import { createEvent } from "@/hooks/form/source-data/useEvent";

interface IExcludedEventAlertProps {
    event: ReturnType<typeof createEvent> | undefined;
}

const ExcludedEventAlert: FC<IExcludedEventAlertProps> = ({ event }) => {
    if (!event?.excluded) {
        return null;
    }

    return (
        <DefaultAlert sx={{ mb: -2 }} icon={<FontAwesomeIcon fixedWidth icon={AppSettings.icons.alertDefault} />}>
            <AlertTitle>Study Event Excluded</AlertTitle>
            <p>
                The study event has been excluded from the selected participant allocation.
            </p>
            <p>
                <strong>Reason:</strong> {event.exclusionReason || "No reason provided."}
            </p>
        </DefaultAlert>
    )
}

export default ExcludedEventAlert;